var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main-header-plat-a'),_c('div',{staticStyle:{"position":"relative"}},[_c('main-header-plat-b',{attrs:{"navBItems":_vm.navBItems}})],1),_c('a',{staticClass:"black--text"},[_vm._v("Solicitadas")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }